import { render, staticRenderFns } from "./FaqAnswer.vue?vue&type=template&id=15f6e242&scoped=true"
import script from "./FaqAnswer.vue?vue&type=script&lang=js"
export * from "./FaqAnswer.vue?vue&type=script&lang=js"
import style0 from "./FaqAnswer.vue?vue&type=style&index=0&id=15f6e242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f6e242",
  null
  
)

export default component.exports